"use client"

import { CopyButton } from "@/components/cron/copy-button"
import { cn } from "@/lib/utils"
import { useState } from "react"

export type CodeTab = {
	label: string
	language: string
	code: string
	html: string
}

type CodeTabsProps = {
	tabs: CodeTab[]
}

export function CodeTabs({ tabs }: CodeTabsProps) {
	const [activeIndex, setActiveIndex] = useState(0)
	const activeTab = tabs[activeIndex]

	if (!activeTab) return null

	return (
		<div className="docs-code-block">
			<div className="docs-code-header">
				<div className="flex gap-1">
					{tabs.map((tab, index) => (
						<button
							key={tab.label}
							type="button"
							onClick={() => setActiveIndex(index)}
							className={cn(
								"px-3 py-1 text-xs font-medium rounded-md transition-colors",
								index === activeIndex
									? "bg-white/10 text-white"
									: "text-white/50 hover:text-white/80",
							)}
						>
							{tab.label}
						</button>
					))}
				</div>
				<CopyButton text={activeTab.code} />
			</div>
			<div className="docs-code-content">
				<div
					className="[&>pre]:!bg-transparent [&>pre]:!p-0 [&>pre]:!m-0 [&_.line]:leading-relaxed"
					// biome-ignore lint/security/noDangerouslySetInnerHtml: shiki output is trusted
					dangerouslySetInnerHTML={{ __html: activeTab.html }}
				/>
			</div>
		</div>
	)
}
